"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = exports.Root = exports.Inner = exports.CarouselContainer = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(6),
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(10)
  }
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(8)
  }
}));
const CarouselContainer = exports.CarouselContainer = (0, _mui.styled)('div')({
  boxSizing: 'border-box',
  width: '100%'
});
const StyledButton = exports.StyledButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  margin: theme.spacing(0, 'auto')
}));
